export const PlayerAvailabilityTableSkeleton = () => {
	return (
		<div className="flex max-w-[560px] animate-pulse flex-col gap-4 bg-white">
			<div className="flex items-center justify-between">
				<div className="h-6 w-32 rounded bg-gray-300" />
				<div className="h-6 w-32 rounded bg-gray-300" />
			</div>

			<table className="w-full text-center">
				<thead>
					<tr className="text-xs">
						<th className="h-6 w-24 rounded bg-gray-300" />
						<th className="h-6 w-36 rounded bg-gray-300" />
						<th className="h-6 w-36 rounded bg-gray-300" />
						<th className="h-6 w-36 rounded bg-gray-300" />
						<th className="h-6 w-36 rounded bg-gray-300" />
					</tr>
				</thead>
				<tbody>
					{[...Array(7)].map((_, rowIndex) => (
						<tr key={`row_index_table_skeleton_${rowIndex}`}>
							<td className="h-7 w-24 rounded bg-gray-300" />
							{[...Array(4)].map((_, colIndex) => (
								<td key={`col_index_table_skeleton_${colIndex}`} className="h-7 w-36 rounded bg-gray-200 p-1" />
							))}
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
};
